import { SimonForm as SimonForm$1 } from '@zillow/zrs-cms';
import React from 'react';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var BlockSimonForm = function BlockSimonForm(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var id = attrs.id,
    persona = attrs.persona,
    _attrs$storageEnviron = attrs.storageEnvironment,
    storageEnvironment = _attrs$storageEnviron === void 0 ? 'Zillow' : _attrs$storageEnviron,
    subscriptionListName = attrs.subscriptionListName,
    treatmentName = attrs.treatmentName;
  return /*#__PURE__*/React.createElement(SimonForm$1, {
    key: index,
    id: id,
    persona: persona,
    storageEnvironment: storageEnvironment,
    subscriptionListName: subscriptionListName,
    treatmentName: treatmentName
  }, generateBlockList({
    blocks: innerBlocks
  }));
};
var SimonForm = BlockSimonForm;

export { SimonForm as default };
